import { EnvironmentProviders, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { DfHeaderUi } from './df-header-ui.interfaces';
import { DfHeaderUiHeaderDirective } from './directive/df-header-ui-header.directive';

export function provideDfModuleHeaderUi(config: DfHeaderUi.IModuleOptions): EnvironmentProviders {
    return makeEnvironmentProviders([
        DfHeaderUiHeaderDirective,
        {
            provide: DfHeaderUi.OPTIONS,
            useValue: config
        },
        provideAppInitializer(() => {
            ICmsContentService.registerComponentMetaPatch(meta => {
                if (meta.id === config.headerComponentId) {
                    meta.fields.push(DfHeaderUi.Field.Block.Title);
                    if (config.fields.transparency) {
                        meta.fields.push(DfHeaderUi.Field.Block.Transparency);
                    }
                    if (config.fields.theme) {
                        meta.fields.push(<NICmsContentField.IChoiceField>{
                            ...DfHeaderUi.Field.Block.Theme,
                            options: getThemeOptions()
                        });
                    }
                }
            });

            ICmsContentService.registerPageMetaPatch(meta => {
                if (config.fields.transparency) {
                    meta.fields?.push(DfHeaderUi.Field.Page.Transparency);
                }
                if (config.fields.theme) {
                    meta.fields?.push(<NICmsContentField.IChoiceField>{
                        ...DfHeaderUi.Field.Page.Theme,
                        options: getThemeOptions()
                    });
                }
            });

            function getThemeOptions(): NICmsContentField.IOption<string>[] {
                const keys = Object.keys(config.fields.theme.options);
                return [{ key: '', title: 'Default' }, ...keys.map(key => ({ key, title: config.fields.theme.options[key] }))];
            }
        })
    ]);
}
